import CustomDatePicker from "@/components/CustomDatePicker";
import {
  CobrancaCltEnum,
  CobrancaCltEnumPt,
  FilterByType,
  Filters,
  FiltersConfig,
  ICobrancaVinculoMetricas,
  MetricsConfig,
  NotificacaoEmailStatusEnum,
  TipoDisparoEmailEnum,
} from "@/models/consignado/proposal-billings.model";
import { removeMaskCpfCnpj } from "@/utils/removeMask";
import {
  Box,
  Flex,
  Tooltip,
  Input,
  Select,
  Button,
  Spinner,
  Checkbox,
  Text,
} from "@chakra-ui/react";
import CompetenciaSelect from "./CompenteciaSelect";

type Props = {
  filtersRef: Filters;
  isLoading: boolean;
  isRefetching: boolean;
  setFiltersRef: React.Dispatch<React.SetStateAction<Filters>>;
  handleFilter: () => void;
  handleClearFilters: () => void;
  filterBy: FilterByType;
  setFilterBy: React.Dispatch<React.SetStateAction<FilterByType>>;
  filtersConfig: FiltersConfig;
  metricasConfig?: MetricsConfig;
  metricas?: ICobrancaVinculoMetricas
};

export function PayrollCollectionsFilters({
  filtersRef,
  isLoading,
  setFiltersRef,
  handleFilter,
  handleClearFilters,
  isRefetching,
  filterBy,
  setFilterBy,
  filtersConfig,
  metricasConfig,
  metricas
}: Props) {
  const handleDateChange = (range: [Date | null, Date | null]) => {
    setFiltersRef((prev) => ({
      ...prev,
      data_pagamento_inicio: range[0] ?? undefined,
      data_pagamento_fim: range[1] ?? undefined,
    }));
  };

  return (
    <Box width="100%">
      <Flex flexDirection="column" gap={4}>
        <Flex gap={4} flexDirection={{ base: "column", md: "row" }}>
          <Box flex={1}>
            <Tooltip label="Filtrar por:" fontSize="md" placement="bottom">
              <Select
                h="3rem"
                bg="white"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filterBy}
                onChange={(e) => {
                  const value = e.target.value as FilterByType;
                  setFilterBy(value);
                  setFiltersRef((prev) => ({
                    ...prev,
                    data_pagamento_inicio: undefined,
                    data_pagamento_fim: undefined,
                    data_competencia: "",
                    status_competencia: "",
                  }));
                }}
              >
                <option value="status">Filtrar por Status</option>
                <option value="competencia">Competência</option>
                <option value="pagamento">Data de pagamento</option>
                <option value="lembrete">Disparo de E-mail</option>
              </Select>
            </Tooltip>
          </Box>

          {filterBy === "status" && (
            <Box flex={1}>
              <Tooltip label="Filtro da Cobrança pelo Status" fontSize="md" placement="bottom">
                <Select
                  h="3rem"
                  bg="white"
                  color="black"
                  fontFamily="Lexend Deca"
                  fontSize="1rem"
                  value={filtersRef.status}
                  onChange={(e) =>
                    setFiltersRef((prev) => ({
                      ...prev,
                      status: e.target.value,
                    }))
                  }
                >
                  <option value="">Selecionar Status da Cobrança</option>
                  <option value={CobrancaCltEnum.PENDING}>
                    {CobrancaCltEnumPt.PENDENTE}
                  </option>
                  <option value={CobrancaCltEnum.DIVERGENT}>
                    {CobrancaCltEnumPt.DIVERGENTE}
                  </option>
                  <option value={CobrancaCltEnum.SUCCESS}>
                    {CobrancaCltEnumPt.SUCESSO}
                  </option>
                  <option value={CobrancaCltEnum.SETTLED}>
                    {CobrancaCltEnumPt.LIQUIDADO}
                  </option>
                  <option value={CobrancaCltEnum.CANCELED}>
                    {CobrancaCltEnumPt.CANCELADO}
                  </option>
                </Select>
              </Tooltip>
            </Box>
          )}

          {filterBy === "pagamento" && (
            <CustomDatePicker
              dateRange={[
                filtersRef.data_pagamento_inicio ?? null,
                filtersRef.data_pagamento_fim ?? null,
              ]}
              onChange={handleDateChange}
            />
          )}

          {filterBy === "competencia" && (
            <>
              <Tooltip label="Filtro pela Data da Competência" fontSize="md" placement="bottom">
                <CompetenciaSelect
                  dataCompetencia={filtersRef.data_competencia}
                  setFiltersRef={setFiltersRef}
                />
              </Tooltip>
              <Box flex={1}>
                <Tooltip label="Filtro pelo status da competência" fontSize="md" placement="bottom">
                  <Select
                    h="3rem"
                    bg="white"
                    color="black"
                    fontFamily="Lexend Deca"
                    fontSize="1rem"
                    value={filtersRef.status_competencia ?? ""}
                    onChange={(e) =>
                      setFiltersRef((prev: any) => ({
                        ...prev,
                        status_competencia: e.target.value,
                      }))
                    }
                  >
                    <option value="">Selecionar Status da Competência</option>

                    <option value="ESCRITURADO">ESCRITURADO</option>

                    <option value="NAO_ESCRITURADO">NÃO ESCRITURADO</option>

                    <option value="REPASSADO">REPASSADO</option>

                    <option value="NAO_REPASSADO">NÃO REPASSADO</option>
                  </Select>
                </Tooltip>
              </Box>
            </>
          )}

          {filterBy === "lembrete" && (
            <>
              <Box flex={1}>
                <Tooltip label="Filtro pela Data da Competência" fontSize="md" placement="bottom">
                  <CompetenciaSelect
                    dataCompetencia={filtersRef.data_competencia}
                    setFiltersRef={setFiltersRef}
                  />
                </Tooltip>
              </Box>

              <Box flex={1}>
                <Tooltip label="Tipo do Disparo de E-mail" fontSize="md" placement="bottom">
                  <Select
                    h="3rem"
                    bg="white"
                    color="black"
                    fontFamily="Lexend Deca"
                    fontSize="1rem"
                    value={filtersRef.tipo_disparo_email}
                    onChange={(e) =>
                      setFiltersRef((prev) => ({
                        ...prev,
                        tipo_disparo_email: e.target.value as TipoDisparoEmailEnum,
                      }))
                    }
                  >
                    <option value="">Selecionar Tipo Disparo</option>
                    <option value={TipoDisparoEmailEnum.NOVO_CONTRATO}>
                      Novo Contrato
                    </option>
                    <option value={TipoDisparoEmailEnum.ESCRITURACAO_ATRASADA}>
                      Escrituração em Atraso
                    </option>
                  </Select>
                </Tooltip>
              </Box>

              <Box flex={1}>
                <Tooltip label="Status do envio" fontSize="md" placement="bottom">
                  <Select
                    h="3rem"
                    bg="white"
                    color="black"
                    fontFamily="Lexend Deca"
                    fontSize="1rem"
                    value={filtersRef.status_envio_email}
                    onChange={(e) =>
                      setFiltersRef((prev) => ({
                        ...prev,
                        status_envio_email: e.target.value as NotificacaoEmailStatusEnum,
                      }))
                    }
                  >
                    <option value="">Selecionar Status</option>
                    <option value={NotificacaoEmailStatusEnum.SUCCESS}>Enviado</option>
                    <option value={NotificacaoEmailStatusEnum.ERROR}>Não Enviado</option>
                  </Select>
                </Tooltip>
              </Box>
            </>
          )}

          <Box flex={1}>
            <Tooltip label="Filtrar por Vendedor" fontSize="md" placement="bottom">
              <Input
                placeholder="Vendedor"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filtersRef.vendedor}
                onChange={(e) => {
                  setFiltersRef((prev) => ({
                    ...prev,
                    vendedor: e.target.value,
                  }));
                }}
              />
            </Tooltip>
          </Box>
        </Flex>
        <Flex gap={4} flexDirection={{ base: "column", md: "row" }}>
          <Box flex={1}>
            <Tooltip label="Filtrar por Corban" fontSize="md" placement="bottom">
              <Input
                placeholder="Corban"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filtersRef.corban}
                onChange={(e) => {
                  setFiltersRef((prev) => ({
                    ...prev,
                    corban: e.target.value,
                  }));
                }}
              />
            </Tooltip>
          </Box>
          <Box flex={1}>
            <Tooltip label="Filtrar por Promotora" fontSize="md" placement="bottom">
              <Input
                placeholder="Promotora"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filtersRef.promotora}
                onChange={(e) => {
                  setFiltersRef((prev) => ({
                    ...prev,
                    promotora: e.target.value,
                  }));
                }}
              />
            </Tooltip>
          </Box>
          <Box flex={1}>
            <Tooltip label="Filtrar por Gerente Comercial" fontSize="md" placement="bottom">
              <Input
                placeholder="Gerente Comercial"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filtersRef.gerente_comercial}
                onChange={(e) => {
                  setFiltersRef((prev) => ({
                    ...prev,
                    gerente_comercial: e.target.value,
                  }));
                }}
              />
            </Tooltip>
          </Box>
          {/* <Box flex={1}>
            <Tooltip label="Filtrar por Período" fontSize="md">
              <Input
                placeholder="Período"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                 value={filtersRef.vendedor}
                onChange={e => {
                  setFiltersRef(prev => ({
                    ...prev,
                    vendedor: e.target.value
                  }))
                }}
              />
            </Tooltip>
          </Box> */}
        </Flex>
        <Flex gap={4} flexDirection={{ base: "column", md: "row" }}>
          <Box flex={1}>
            <Tooltip label="Filtrar por Tomador" fontSize="md" placement="bottom">
              <Input
                placeholder="Tomador"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filtersRef.tomador}
                onChange={(e) => {
                  setFiltersRef((prev) => ({
                    ...prev,
                    tomador: e.target.value,
                  }));
                }}
              />
            </Tooltip>
          </Box>
          <Box flex={1}>
            <Tooltip label="Filtrar por Empresa" fontSize="md" placement="bottom">
              <Input
                placeholder="Empresa"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filtersRef.empregador}
                onChange={(e) => {
                  setFiltersRef((prev) => ({
                    ...prev,
                    empregador: removeMaskCpfCnpj(e.target.value),
                  }));
                }}
              />
            </Tooltip>
          </Box>
          <Box flex={1}>
            <Tooltip label="Filtrar por CCB/ShortHash" fontSize="md" placement="bottom">
              <Input
                placeholder="CCB/ShortHash"
                bg="white"
                height="3rem"
                color="black"
                fontFamily="Lexend Deca"
                fontSize="1rem"
                value={filtersRef.codigo_proposta}
                onChange={(e) => {
                  setFiltersRef((prev) => ({
                    ...prev,
                    codigo_proposta: e.target.value,
                  }));
                }}
              />
            </Tooltip>
          </Box>
        </Flex>

        <Flex
          width="100%"
          alignItems="center"
          justifyContent="space-between"
          gap={4}
          mt={4}
        >
          {(metricasConfig?.enabled && metricas) && (
            <Flex width='50%' alignItems='center' gap={4}>
              <Box w="8px" h="8px" borderRadius="full" bg="red.300" />
              <Text>Encerrados: {metricas?.encerrados ?? 0}</Text>
              <Box w="8px" h="8px" borderRadius="full" bg="green.300" />
              <Text>Novos: {metricas?.novos ?? 0}</Text>
            </Flex>
          )}
     
          <Flex width='100%' alignItems="center" justifyContent='end' gap={4}>
            <Select
              value={filtersRef.order}
              colorScheme="primary"
              w="fit-content"
              onChange={(e: any) =>
                setFiltersRef((prev) => ({ ...prev, order: e.target.value }))
              }
            >
              <option value="DESC" style={{ color: "black" }}>
                Mais recentes
              </option>
              <option value="ASC" style={{ color: "black" }}>
                Mais antigas
              </option>
            </Select>
            {filtersConfig.novos_vinculos.enabled && (
              <Box>
                <Checkbox
                  isChecked={filtersRef.novos_vinculos ?? false}
                  onChange={(e) =>
                    setFiltersRef((prev) => ({
                      ...prev,
                      novos_vinculos: e.target.checked,
                    }))
                  }
                >
                  Novos Vínculos
                </Checkbox>
              </Box>
            )}
            <Button variant="ghost" colorScheme="primary" onClick={handleClearFilters}>
              Limpar Filtros
            </Button>
            <Button
              display="flex"
              gap={2}
              alignItems="center"
              colorScheme="primary"
              onClick={handleFilter}
            >
              {(isLoading || isRefetching) && <Spinner size="sm" />} Filtrar
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
}
